import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const getOrderCancelReasons = async (params: object) => {
  return await GET({
    url: Api.getOrderCancelReasons,
    params,
    showError: false,
    headers: {
      'Client-Id': 'iss_courier'
    }
  })
}
export const abortOrder = async (params: object) => {
  return await POST({
    url: Api.abortOrder,
    data: params,
    showError: false,
    headers: {
      rpcType: 'dubbo',
      'Content-Type': 'application/json'
    },
    dataType: 'json'
  })
}
export const queryCourierChance = async (params: object) => {
  return await GET({
    url: Api.queryCourierChance,
    params,
    showError: false
  })
}
